import { TableFields } from "../TableFields.types";

export function areSameFields(fields: Array<string>, otherFields: Array<string>): boolean {
    return fields.length === otherFields.length && fields.every((fieldId, index) => fieldId === otherFields[index]);
}

// A view saved while a column was still available, such as one behind an addon, can name a column this list no
// longer offers. Kept, it would count as a change nobody can see or undo.
export function onlyAvailableFields(fields: Array<string>, options: Array<TableFields>): Array<string> {
    return fields.filter((fieldId) => options.some((option) => option.id === fieldId));
}

/**
 * Moves a field to where another one is. Taken by id rather than by index, because the shown list can be narrowed by
 * the search, and an index into the narrowed list says nothing about where the field sits among all of them.
 */
export function moveField(fields: Array<string>, fieldId: string, toFieldId: string): Array<string> {
    const destinationIndex = fields.indexOf(toFieldId);
    const moved = fields.filter((id) => id !== fieldId);
    moved.splice(destinationIndex, 0, fieldId);
    return moved;
}

export function toggleField(fields: Array<string>, fieldId: string): Array<string> {
    if (fields.includes(fieldId)) {
        return fields.filter((id) => id !== fieldId);
    }

    return [...fields, fieldId];
}
